import { type IntlShape } from 'react-intl';

export const WAYPOINT_DECIMAL_PLACES = 6;
export const WAYPOINT_ZOOM = 15;

export const getGeneralError = (intl: IntlShape) => ({
  iconCode: 'error',
  message: intl.formatMessage({ defaultMessage: "We couldn't complete this action. Give it another try!" })
});
